import { Observable } from 'rxjs';
import { LoggerService } from 'src/app/services/logger/logger.service';

export interface ISectionPresenter {
	isVisible(): Promise<boolean>;
}

export abstract class SectionPresenter implements ISectionPresenter {
	protected abstract checkFeaturesCapabilities(): Observable<{ value: boolean; type: string }>;
	protected abstract isFeatureToggleEnabled(): boolean;
	protected abstract initializeLoadedResult(): any;

	constructor(protected logger: LoggerService) {}

	public isVisible(): Promise<boolean> {
		const isFeatureToggleEnabled = this.isFeatureToggleEnabled();
		if (!isFeatureToggleEnabled) return Promise.resolve(false);

		return new Promise(this.handleHasAnyFeatureCapability.bind(this));
	}

	private handleHasAnyFeatureCapability(resolve: (result: boolean) => void) {
		const loadedFeatures = this.initializeLoadedResult();
		const handlerNext = (result: { value: boolean; type: string }) => {
			const nextResult = this.checkCapabilitiesNextHandler(result, loadedFeatures);
			if (nextResult.isResolved) {
				resolve(nextResult.resolvedResult);
				checkCapabilitiesSubscription.unsubscribe();
			}
		};
		const checkCapabilitiesObservable = this.checkFeaturesCapabilities();
		const checkCapabilitiesSubscription = checkCapabilitiesObservable.subscribe({
			next: handlerNext.bind(this),
			error: () => resolve(false),
		});
	}

	private checkCapabilitiesNextHandler(
		result: { value: boolean; type: string },
		loadedFeatures: any
	) {
		let isResolved = false;
		let resolvedResult = false;
		this.logger.info('SectionPresenter:checkCapabilitiesNextHandler', result);

		loadedFeatures[result.type] = true;
		if (result.value) {
			isResolved = true;
			resolvedResult = true;
		} else {
			isResolved = this.isAllFeaturesLoaded(loadedFeatures);
		}

		return { isResolved, resolvedResult };
	}

	private isAllFeaturesLoaded(loadedFeatures: any): boolean {
		let isAllLoaded: boolean = true;
		for (let keys in loadedFeatures) {
			isAllLoaded = isAllLoaded && loadedFeatures[keys];
		}
		return isAllLoaded;
	}
}
